const DEFAULT_TOKEN_TTL_SECONDS = 86400; // 24 hours
const DEFAULT_MAX_RESEND_ATTEMPTS = 15;
const DEFAULT_RESEND_COOLDOWN_SECONDS = 60; // 1 minute

export const emailVerificationConfig = {
  secret: process.env.NEXTAUTH_SECRET,
  tokenTtlInSeconds:
    Number(process.env.EMAIL_VERIFICATION_TOKEN_TTL_IN_SECS) || DEFAULT_TOKEN_TTL_SECONDS,
  maxResendAttempts:
    Number(process.env.EMAIL_VERIFICATION_MAX_RESEND_ATTEMPTS) || DEFAULT_MAX_RESEND_ATTEMPTS,
  resendCooldownInSeconds:
    Number(process.env.EMAIL_VERIFICATION_RESEND_COOLDOWN_SECS) || DEFAULT_RESEND_COOLDOWN_SECONDS,
} as const;
